import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import React, { useMemo } from "react";
import { t } from "utilities/localization-utils";

interface OpenChecklistItemNoteModalButtonProps {
    cssClassName: string;
    handleOpen: () => void;
    noteId: number;
}

const CSS_CLASS_NAME: string = "c-open-checklist-item-note-modal-button";

export const OpenChecklistItemNoteModalButton: React.FC<
    OpenChecklistItemNoteModalButtonProps
> = ({ cssClassName, handleOpen, noteId }) => {
    const icon = useMemo(
        () => (noteId === 0 ? Icons.EmptyNotes : Icons.EditNotes),
        [noteId]
    );
    const wrapperClassModifier = useMemo(
        () => (noteId === 0 ? "-create" : "-edit"),
        [noteId]
    );

    return (
        <Button
            cssClassName={`${CSS_CLASS_NAME} ${cssClassName}`.trim()}
            onClick={handleOpen}
            style={ButtonStyles.None}>
            <span className="sr-only">{t("checklist-item-note")}</span>
            <div
                className={`${CSS_CLASS_NAME}__icon-wrapper ${wrapperClassModifier}`}>
                <Icon size={IconSizes.Small} type={icon} />
            </div>
        </Button>
    );
};
